/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';

import APP_CONSTANTS from '../../config/constants';


const ProductSKUDropdown = ({
    field: { name },
    form: { setFieldValue },
    getProductData,
    productSelectedArray,
    handleUpdateProduct,
    productIndex,
    productObject,
    selectedProductEdit,
    ...props
}) => {

    const [productData, setProductData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState("")

    useEffect(() => {
        setIsLoading(true)
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo
            })

        Axios.get(`${APP_CONSTANTS.BASE_URL}masters/psLineItem?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setProductData(response.data.resultSet)
            getProductData && getProductData(response.data.resultSet)
            setIsLoading(false)
            setSelectedProduct(selectedProductEdit)
        }))
            .catch(error => console.log(error))
        setIsLoading(false)
    }, [])


    let filteredOptions = []
    if (productData && productData.length > 0) {
        productData.map((object, index) => {
            let temp = {}

            function containsPSId(obj, list) {
                var i;
                for (i = 0; i < list.length; i++) {
                    if (list[i].productName === obj.psId && list[i].productName !== selectedProduct) {
                        return true;
                    }
                }


                return false;
            }

            if (!containsPSId(object, productSelectedArray)) {
                temp.key = object.psId
                temp.text = object.psDescription
                temp.value = object.psId

            }

            return filteredOptions[index] = temp
        })
    }

    let options = filteredOptions.filter((item) => {
        if (item.key) {
            return item
        }

    })

    return (
        <Dropdown
            search
            selection
            onChange={(e, data) => { handleUpdateProduct(e, data, productIndex, productObject); setSelectedProduct(data.value);setFieldValue(name,data.value); }}
            options={options}
            clearable
            loading={isLoading}
            {...props}
            fluid
        />
    )
}


export default ProductSKUDropdown